export const pedidos_mixin = {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Object,
    pedidos: Array
  },
  computed: {
    PEDIDO_SELECIONADO: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        return this.$emit('update:modelValue', valor);
      }
    },
    CALLBACK_ATUALIZAR_PEDIDOS_CARRINHO() {
      return this.$store.getters['CompraProdutosGerais/callbackRecarregarPedidosCompraCarrinho'];
    }
  }
}
